const ONE_HOUR_IN_SECONDS: number = 60 * 60;

export { ONE_HOUR_IN_SECONDS };
